import styled from 'styled-components'

const GroupLabel = styled.span`
    display: flex;
    margin: 8px 7px 4px;
    min-height: 21px;
`

export default GroupLabel